import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { Button, Heading, Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import useEnableRotaTrial from 'screens/Rostering/hooks/useEnableRotaTrial'

type RotaPaywallModalProps = {
  showPrompt: boolean
  setShowPrompt: (showPrompt: boolean) => void
}

const RotaPaywallModal = ({
  showPrompt,
  setShowPrompt,
}: RotaPaywallModalProps) => {
  const { t } = useTranslation()

  const { enableRotaTrial } = useEnableRotaTrial()

  const handleConfirm = () => {
    enableRotaTrial()
    setShowPrompt(false)
  }

  return (
    <Modal
      open={showPrompt}
      onCancel={() => setShowPrompt(false)}
      footer={[
        <ModalFooter>
          <Button onClick={() => setShowPrompt(false)}>{t('NO_CANCEL')}</Button>

          <Button variant="primary" onClick={handleConfirm}>
            {t('YES_CONTINUE')}
          </Button>
        </ModalFooter>,
      ]}
    >
      <ConfirmationModalContent>
        <Heading level={3}>{t('ROTA_PAYWALL_MODAL_TITLE')}</Heading>
        <Divider />
        <BulletList>
          <BulletItem>
            <Text>{t('ROTA_PAYWALL_BULLET_1')}</Text>
          </BulletItem>
          <BulletItem>
            <Text>{t('ROTA_PAYWALL_BULLET_2')}</Text>
          </BulletItem>
        </BulletList>
        <Divider />
      </ConfirmationModalContent>
    </Modal>
  )
}

const ModalFooter = styled.div`
  margin-top: 12px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`
const ConfirmationModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: ${(props) => props.theme.color.neutral.color3};
`

const BulletList = styled.ul`
  list-style-type: disc;
  margin: 0;
  padding-left: 24px;
`

const BulletItem = styled.li`
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
`

export default RotaPaywallModal
